/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehiclePaginationResponseAllOfDataInner
 */
export interface VehiclePaginationResponseAllOfDataInner {
    /**
     * 車両ID
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    carId: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    updateTimestamp: string;
    /**
     * 無線番号
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    radioNo: string;
    /**
     * ナンバープレート上部
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    plateNoUpper?: string;
    /**
     * ナンバープレート下部
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    plateNoBottom?: string;
    /**
     * ドア番号
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    doorNo?: string;
    /**
     * 車種コード
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    carTypeCode?: string;
    /**
     * 車種名
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    carTypeName?: string;
    /**
     * 車体色 (RGB)
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    colorRgb?: string;
    /**
     * グループコード
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    companyCode: string;
    /**
     * グループ名
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    companyName?: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    companyId: string;
    /**
     * 会社名
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    subCompanyName?: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    salesOfficeId: string;
    /**
     * 営業所名
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    salesOfficeName: string;
    /**
     * 配車可能フラグ
     * @type {boolean}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    available: boolean;
    /**
     * 事業者連絡機能可否フラグ
     * @type {boolean}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    companyMsgAvailable: boolean;
    /**
     * 初度登録年月 (YYYY/MM)
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    firstRegistrationDate?: string;
    /**
     * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し)
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    meterMode: string;
    /**
     * 個人タクシー事業者名（個人タクシーのみ）
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    ownerDrivenTaxiName?: string;
    /**
     * インボイス番号（個人タクシーのみ）
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    invoiceNo?: string;
    /**
     * 備考
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    description?: string;
    /**
     * QR連携用コード
     * @type {string}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    tabletTerminalId?: string;
    /**
     * 楽観ロック制御用のバージョン番号
     * @type {number}
     * @memberof VehiclePaginationResponseAllOfDataInner
     */
    version: number;
}

/**
 * Check if a given object implements the VehiclePaginationResponseAllOfDataInner interface.
 */
export function instanceOfVehiclePaginationResponseAllOfDataInner(value: object): value is VehiclePaginationResponseAllOfDataInner {
    if (!('carId' in value) || value['carId'] === undefined) return false;
    if (!('updateTimestamp' in value) || value['updateTimestamp'] === undefined) return false;
    if (!('radioNo' in value) || value['radioNo'] === undefined) return false;
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('salesOfficeId' in value) || value['salesOfficeId'] === undefined) return false;
    if (!('salesOfficeName' in value) || value['salesOfficeName'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('companyMsgAvailable' in value) || value['companyMsgAvailable'] === undefined) return false;
    if (!('meterMode' in value) || value['meterMode'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function VehiclePaginationResponseAllOfDataInnerFromJSON(json: any): VehiclePaginationResponseAllOfDataInner {
    return VehiclePaginationResponseAllOfDataInnerFromJSONTyped(json, false);
}

export function VehiclePaginationResponseAllOfDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehiclePaginationResponseAllOfDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'carId': json['car_id'],
        'updateTimestamp': json['update_timestamp'],
        'radioNo': json['radio_no'],
        'plateNoUpper': json['plate_no_upper'] == null ? undefined : json['plate_no_upper'],
        'plateNoBottom': json['plate_no_bottom'] == null ? undefined : json['plate_no_bottom'],
        'doorNo': json['door_no'] == null ? undefined : json['door_no'],
        'carTypeCode': json['car_type_code'] == null ? undefined : json['car_type_code'],
        'carTypeName': json['car_type_name'] == null ? undefined : json['car_type_name'],
        'colorRgb': json['color_rgb'] == null ? undefined : json['color_rgb'],
        'companyCode': json['company_code'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'companyId': json['company_id'],
        'subCompanyName': json['sub_company_name'] == null ? undefined : json['sub_company_name'],
        'salesOfficeId': json['sales_office_id'],
        'salesOfficeName': json['sales_office_name'],
        'available': json['available'],
        'companyMsgAvailable': json['company_msg_available'],
        'firstRegistrationDate': json['first_registration_date'] == null ? undefined : json['first_registration_date'],
        'meterMode': json['meter_mode'],
        'ownerDrivenTaxiName': json['owner_driven_taxi_name'] == null ? undefined : json['owner_driven_taxi_name'],
        'invoiceNo': json['invoice_no'] == null ? undefined : json['invoice_no'],
        'description': json['description'] == null ? undefined : json['description'],
        'tabletTerminalId': json['tablet_terminal_id'] == null ? undefined : json['tablet_terminal_id'],
        'version': json['version'],
    };
}

export function VehiclePaginationResponseAllOfDataInnerToJSON(json: any): VehiclePaginationResponseAllOfDataInner {
    return VehiclePaginationResponseAllOfDataInnerToJSONTyped(json, false);
}

export function VehiclePaginationResponseAllOfDataInnerToJSONTyped(value?: VehiclePaginationResponseAllOfDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'car_id': value['carId'],
        'update_timestamp': value['updateTimestamp'],
        'radio_no': value['radioNo'],
        'plate_no_upper': value['plateNoUpper'],
        'plate_no_bottom': value['plateNoBottom'],
        'door_no': value['doorNo'],
        'car_type_code': value['carTypeCode'],
        'car_type_name': value['carTypeName'],
        'color_rgb': value['colorRgb'],
        'company_code': value['companyCode'],
        'company_name': value['companyName'],
        'company_id': value['companyId'],
        'sub_company_name': value['subCompanyName'],
        'sales_office_id': value['salesOfficeId'],
        'sales_office_name': value['salesOfficeName'],
        'available': value['available'],
        'company_msg_available': value['companyMsgAvailable'],
        'first_registration_date': value['firstRegistrationDate'],
        'meter_mode': value['meterMode'],
        'owner_driven_taxi_name': value['ownerDrivenTaxiName'],
        'invoice_no': value['invoiceNo'],
        'description': value['description'],
        'tablet_terminal_id': value['tabletTerminalId'],
        'version': value['version'],
    };
}

